"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var Shop = function Shop(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    fill: "currentColor",
    d: "M19.895 9.966a2.21 2.21 0 01-3.905-.164 2.208 2.208 0 01-3.99 0 2.208 2.208 0 01-3.989 0 2.21 2.21 0 01-3.906.164A1.802 1.802 0 014.04 8.35l1.336-3.092c.2-.461.655-.759 1.157-.758h10.936c.503 0 .958.297 1.158.758l1.336 3.092c.234.518.21 1.118-.067 1.616zM7.781 15.75a.156.156 0 01-.157-.156v-.938c0-.086.07-.156.157-.156h8.44c.086 0 .156.07.156.156v.938c0 .086-.07.156-.157.156H7.78zm-1.718-4.063h.625c.173 0 .313.14.313.313v3.75a.625.625 0 00.625.625h8.749c.345 0 .625-.28.625-.625V12c0-.173.14-.313.313-.313h.625c.172 0 .312.14.312.313v6.25A1.25 1.25 0 0117 19.5H7a1.25 1.25 0 01-1.25-1.25V12a.313.313 0 01.313-.313z"
  }));
};

var _default = (0, _react.forwardRef)(Shop);

var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Shop, "Shop", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Shop.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Shop.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9JY29ucy9TaG9wLnRzeCJdLCJuYW1lcyI6WyJTaG9wIiwicHJvcHMiLCJyZWYiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7QUFBQTs7Ozs7Ozs7Ozs7OztBQUVBLElBQU1BLElBQW9FLEdBQUcsU0FBdkVBLElBQXVFLENBQUNDLEtBQUQsRUFBUUMsR0FBUjtBQUFBLFNBQzNFO0FBQUssSUFBQSxLQUFLLEVBQUUsRUFBWjtBQUFnQixJQUFBLE1BQU0sRUFBRSxFQUF4QjtBQUE0QixJQUFBLE9BQU8sRUFBQztBQUFwQyxLQUFvREQsS0FBcEQ7QUFBMkQsSUFBQSxHQUFHLEVBQUVDO0FBQWhFLE1BQ0U7QUFDRSxJQUFBLElBQUksRUFBQyxjQURQO0FBRUUsSUFBQSxDQUFDLEVBQUM7QUFGSixJQURGLENBRDJFO0FBQUEsQ0FBN0U7O2VBU2UsdUJBQVdGLElBQVgsQzs7Ozs7Ozs7Ozs7OzswQkFUVEEsSSIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCwgeyBmb3J3YXJkUmVmLCBSZWZGb3J3YXJkaW5nQ29tcG9uZW50LCBTVkdQcm9wcyB9IGZyb20gJ3JlYWN0JztcblxuY29uc3QgU2hvcDogUmVmRm9yd2FyZGluZ0NvbXBvbmVudDxTVkdTVkdFbGVtZW50LCBTVkdQcm9wczxTVkdTVkdFbGVtZW50Pj4gPSAocHJvcHMsIHJlZikgPT4gKFxuICA8c3ZnIHdpZHRoPXsyNH0gaGVpZ2h0PXsyNH0gdmlld0JveD1cIjAgMCAyNCAyNFwiIHsuLi5wcm9wc30gcmVmPXtyZWZ9PlxuICAgIDxwYXRoXG4gICAgICBmaWxsPVwiY3VycmVudENvbG9yXCJcbiAgICAgIGQ9XCJNMTkuODk1IDkuOTY2YTIuMjEgMi4yMSAwIDAxLTMuOTA1LS4xNjQgMi4yMDggMi4yMDggMCAwMS0zLjk5IDAgMi4yMDggMi4yMDggMCAwMS0zLjk4OSAwIDIuMjEgMi4yMSAwIDAxLTMuOTA2LjE2NEExLjgwMiAxLjgwMiAwIDAxNC4wNCA4LjM1bDEuMzM2LTMuMDkyYy4yLS40NjEuNjU1LS43NTkgMS4xNTctLjc1OGgxMC45MzZjLjUwMyAwIC45NTguMjk3IDEuMTU4Ljc1OGwxLjMzNiAzLjA5MmMuMjM0LjUxOC4yMSAxLjExOC0uMDY3IDEuNjE2ek03Ljc4MSAxNS43NWEuMTU2LjE1NiAwIDAxLS4xNTctLjE1NnYtLjkzOGMwLS4wODYuMDctLjE1Ni4xNTctLjE1Nmg4LjQ0Yy4wODYgMCAuMTU2LjA3LjE1Ni4xNTZ2LjkzOGMwIC4wODYtLjA3LjE1Ni0uMTU3LjE1Nkg3Ljc4em0tMS43MTgtNC4wNjNoLjYyNWMuMTczIDAgLjMxMy4xNC4zMTMuMzEzdjMuNzVhLjYyNS42MjUgMCAwMC42MjUuNjI1aDguNzQ5Yy4zNDUgMCAuNjI1LS4yOC42MjUtLjYyNVYxMmMwLS4xNzMuMTQtLjMxMy4zMTMtLjMxM2guNjI1Yy4xNzIgMCAuMzEyLjE0LjMxMi4zMTN2Ni4yNUExLjI1IDEuMjUgMCAwMTE3IDE5LjVIN2ExLjI1IDEuMjUgMCAwMS0xLjI1LTEuMjVWMTJhLjMxMy4zMTMgMCAwMS4zMTMtLjMxM3pcIlxuICAgIC8+XG4gIDwvc3ZnPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgZm9yd2FyZFJlZihTaG9wKTtcbiJdfQ==